import { useTranslation } from 'react-i18next';

export function useLocalizedCountryName(
  locale?: string,
  fallback: 'code' | 'none' = 'code',
): {
  getLocalizedCountry: (isoCode: string) => string | null;
} {
  const { i18n } = useTranslation();

  const getLocalizedCountry = (isoCode: string) => {
    try {
      const displayNames = new Intl.DisplayNames([locale ?? i18n.language], {
        type: 'region',
        fallback,
      });
      return displayNames.of(isoCode.trim().toUpperCase()) ?? null;
    } catch {
      return null;
    }
  };

  return {
    getLocalizedCountry,
  };
}
